import 'swiper-9/swiper-bundle.min.css';
import OuterSwiperSlides from '~/javascripts/components/User/ProfileMap/OuterSwiperSlides';
import Swiper, { Pagination } from 'swiper-9';
import cx from 'classnames';
import store from '~/javascripts/store.js';
import { observer, useLocalObservable } from 'mobx-react';
import { useEffect } from 'react';

const OuterSwiper = observer(() => {
  const localStore = useLocalObservable(() => ({
    outerSwiper: null,
  }));

  useEffect(() => {
    if (store.projectDetailsMap.projectsList.size > 0) {
      initializeOuterSwiper();
    }
  }, [store.projectDetailsMap.projectsList]);

  useEffect(() => {
    if (store.projectDetailsMap.focusedProjectId) {
      slideToSelectedCountry();
    }
  }, [store.projectDetailsMap.focusedProjectId]);

  const slideToSelectedCountry = () => {
    const outerSlideForCountry = document.querySelector(
      `.swiper-slide[data-country='${store.projectDetailsMap.selectedCountryCode}']`
    );
    store.projectDetailsMap.outerSwiperSlideIndex =
      outerSlideForCountry.dataset.swiperSlideIndex;
    slideToOuterIndex();
  };

  const slideToOuterIndex = () => {
    if (localStore.outerSwiper) {
      localStore.outerSwiper.update();
      localStore.outerSwiper.slideTo(
        store.projectDetailsMap.outerSwiperSlideIndex,
        0,
        false
      );
    }
  };

  const initializeOuterSwiper = () => {
    localStore.outerSwiper = new Swiper('.outer-slider', {
      modules: [Pagination],
      simulateTouch: false,
      initialSlide: store.projectDetailsMap.outerSwiperSlideIndex,
      direction: 'horizontal',
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      grabCursor: false,
      allowTouchMove: false,
      speed: 400,
      parallax: true,
      effect: 'slide',
      mousewheelControl: 1,
      on: {
        activeIndexChange: () => {
          if (store.projectDetailsMap.focusedProjectId) {
            store.projectDetailsMap.focusedProjectId = null;
          } else {
            setOuterSlideIndexAndCountry();
          }
        },
        afterInit: (outerSwiper) => {
          setSelectedCountry(outerSwiper);
          slideToOuterIndex(outerSwiper);
          store.projectDetailsMap.outerSwiperInitialized = true;
        },
        click: () => {
          store.projectDetailsMap.focusedProjectId = null;
        },
      },
      breakpoints: {
        750: {
          grabCursor: true,
          allowTouchMove: true,
          simulateTouch: true,
        },
      },
    });
  };

  const setOuterSlideIndexAndCountry = () => {
    resetInnerSwiper();

    if (localStore.outerSwiper) {
      setSelectedCountry(localStore.outerSwiper);
      store.projectDetailsMap.outerSwiperSlideIndex =
        localStore.outerSwiper.realIndex;
    }
  };

  const resetInnerSwiper = () => {
    store.projectDetailsMap.innerSwiperSlideIndex = 0;
  };

  const setSelectedCountry = (outerSwiper) => {
    const outerSwiperActiveSlide = document.querySelector(
      `.outer-slider > .swiper-wrapper > .swiper-slide[data-swiper-slide-index='${outerSwiper.realIndex}']`
    );
    store.projectDetailsMap.selectedCountryCode =
      outerSwiperActiveSlide.dataset.country;
  };

  return (
    <>
      <div
        className={cx('outer-slider swiper nice-parallax', {
          inactive: store.projectDetailsMap.displayMap,
        })}
      >
        <div className='swiper-wrapper'>
          <OuterSwiperSlides />
        </div>
        <div
          className='swiper-pagination'
          onClick={setOuterSlideIndexAndCountry}
        />
      </div>
    </>
  );
});

export default OuterSwiper;
